import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
import moment from "moment";
import ACTIONS from '../../actions/lexon';
import CU_ACTIONS from '../../actions/user';
import { setFormValues } from '../../actions/login';
import { clearUserCredentials } from '../../actions/application';
import { PROVIDER } from '../../constants';
import { getTokenImap, getUserAccounts } from '../../services/accounts';
import { removeState } from '../../services/state';
import * as base64 from 'base-64';
import { withClassNavigate } from '../../hocs/withClassNavigate';
import { withRouter } from '../../hocs/withRouter';
import {
  parseJwt,
  getUserId,
  getIdCasefile,
  getBbdd,
  getIdCompany,
  getMailContacts,
  getIdMail,
  getImapFolder,
  getIdClienteLef,
  getIdResponsable,
  getDocumentsId,
  getInterveners,
  getSubject,
  getAcceptCookies,
  getIsCompose,
} from '../../services/jwt';

class UserLexon extends Component {
  constructor(props) {
    super(props);

    this.state = {
      readyToRedirect: false,
      readyToRedirectToLogin: false,
      isNewAccount: false
    };

    this.isUniqueAccountByProvider = this.isUniqueAccountByProvider.bind(this);
  }

  async componentDidMount() {
    let parametros;
    if (
      this.props.location.search.indexOf('account=') > -1 ||
      this.props.location.search.indexOf('prov=') > -1
    ) {
      parametros = new URLSearchParams(this.props.location.search);
      if (parametros.get('account')) {
        // Get user account
        let account = base64.decode(parametros.get('account'));
        if (account === 'undefined' || account === undefined) {
          account = null;
        }
        if (account) {
          this.props.setAccount(account);
        }
      }
    }
    this.props.setLexonToken(this.props.match.params.token);
    const payload = this.props.match.params.token
      ? parseJwt(this.props.match.params.token)
      : undefined;
    if (payload) {
      const aux = { ...payload };
      delete aux.exp;
      // PEC-1557: el consentimiento de cookies se deriva SIEMPRE del token de entrada (nunca del
      // currentUser persistido) para que un `true` antiguo no arranque Clarity sin consentimiento.
      aux.accept_cookies = getAcceptCookies(payload);
      window.currentUser = aux;

      if (this.props.currentUser?.documentsId && this.props.currentUser?.documentsId.length > 0) {
        const currentDocumentsId = Array.isArray(this.props.currentUser?.documentsId) ?
          this.props.currentUser.documentsId : [];
        const auxDocumentsId = Array.isArray(aux?.documentsId) ? aux.documentsId : [];
        const newDocumentsId = [...currentDocumentsId, ...auxDocumentsId];
        aux.documentsId = newDocumentsId.filter((id, index) => newDocumentsId.indexOf(id) === index);
      }

      this.props.setCurrentUser(aux);
    }
    let user = this.props.match.params.token
      ? getUserId(payload)
      : this.props.match.params.idUser;

    const casefile = this.props.match.params.token
      ? getIdCasefile(payload)
      : this.props.match.params.idCaseFile;

    const bbdd = this.props.match.params.token
      ? getBbdd(payload)
      : this.props.match.params.bbdd;

    const idCompany = this.props.match.params.token
      ? getIdCompany(payload)
      : this.props.match.params.idCompany;

    const idMessage = this.props.match.params.token
      ? getIdMail(payload)
      : this.props.match.params.idMessage;

    let idFolder = this.props.match.params.token
      ? getImapFolder(payload)
      : this.props.match.params.idFolder;

    const mailContacts = this.props.match.params.token
      ? getMailContacts(payload)
      : this.props.match.params.mailContacts;

    const idClienteLef = this.props.match.params.token
      ? getIdClienteLef(payload)
      : null;

    const documentsId = this.props.match.params.token
      ? getDocumentsId(payload)
      : this.props.match.params.documentsId;

    const interveners = this.props.match.params.token
      ? getInterveners(payload)
      : this.props.match.params.interveners;

    const subjectEmail = this.props.match.params.token ?
      getSubject(payload) : this.props.match.params.subject;

    const isCompose = this.props.match.params.token
      ? getIsCompose(payload)
      : this.props.match.params.compose;

    if (this.props.location.search.indexOf('prov=') > -1) {
      user = `${parametros.get('prov')}${user}`;
    }

    if (user !== this.props.lexon.user) {
      this.props.setFormValues({
        imap: '',
        imapUser: '',
        imapPass: '',
        smtp: ''
      });
      this.props.logout();
    }

    const idUserResponsable = getIdResponsable(payload);
    this.props.setIdResponsable(idUserResponsable);
    this.props.setIdClientLef(idClienteLef);
    this.props.setUser(user);

    if (idFolder === null || idFolder === undefined || idFolder === 'NULL') {
      idFolder = 'INBOX';
    }

    if (casefile) {
      this.props.setCaseFile({
        casefile: casefile,
        bbdd: bbdd,
        idCompany: idCompany
      });
    } else if (bbdd) {
      this.props.setDataBase({
        bbdd: bbdd,
        idCompany: idCompany
      });
    }
    if (idMessage) {
      this.props.setIdEmail({
        idEmail: idMessage.replace('[', '').replace(']', ''),
        idFolder: idFolder,
        emailShown: false
      });
    } else {
      this.props.setIdEmail({
        idEmail: undefined,
        idFolder: undefined,
        emailShown: false
      });
    }

    if (interveners) {
      this.props.setInterveners(interveners);
    }

    if (isCompose) {
      this.props.setIsCompose(isCompose);
    }

    if (documentsId) {
      let documentIds = [...documentsId];
      if (this.props.currentUser.documentsId && this.props.currentUser.documentsId.length > 0) {
        const currentDocumentsId = Array.isArray(this.props.current_user?.documentsId) ?
          this.props.current_user.documentsId : [];
        const docIds = Array.isArray(documentsId) ? documentsId : [documentsId];

        const newDocumentsId = [...currentDocumentsId, ...docIds];
        documentIds = newDocumentsId.filter((id, index) => newDocumentsId.indexOf(id) === index);
      }
      this.props.setDocumentsId(documentIds);
    }

    if (subjectEmail) {
      this.props.setSubjectEmail(subjectEmail);
    }

    if (mailContacts) {
      this.props.setMailContacts(mailContacts);
    }
    const portalTokenUtils = await getTokenImap(this.props.match.params.token);
    if (this.props.match.params.token && !documentsId) {
      this.props.setToken(portalTokenUtils.data);
    } else {
      this.props.setLexonToken(portalTokenUtils.data.replace('/', ''));
      this.props.setToken(portalTokenUtils.data);
    }
    const date = new Date();
    const lastConnection = moment(date).format('DD/MM/YYYY - HH:mm');
    this.props.setLastConnection(lastConnection);
    this.setState({ isNewAccount: user.slice(2, 3) === '1' ? true : false });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.lexon !== this.props.lexon) {
      if (this.props.lexon.isNewAccount) {
        removeState();
        this.setState({
          readyToRedirect: true
        });
      } else {
        this.isUniqueAccountByProvider();
      }
    }
  }

  async isUniqueAccountByProvider() {
    const { lexon } = this.props;
    const result = getUserAccounts(lexon.userId, lexon.lexonToken);

    if (result.errors?.length === 0) {
      const accountsByProvider = result.data.accounts.filter(
        account => account.provider === PROVIDER
      );
      const userAccount = accountsByProvider.filter(a => a.email === this.props.lexon.account);
      if (userAccount) {
        this.props.setConfigCalendar(userAccount.configCalendar);
      }
      if (accountsByProvider.length > 1) {
        this.setState({
          readyToRedirectToLogin: true
        });
      } else {
        this.setState({
          readyToRedirect: true
        });
      }
    }
  }

  render() {
    const {
      readyToRedirect
    } = this.state;
    if (readyToRedirect) {
      return <Navigate to='/' replace />;
    }

    return <Navigate to='/' replace />;
  }
}

const mapStateToProps = state => ({
  lexon: state.lexon,
  currentUser: state.currentUser
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  setUser: user => dispatch(ACTIONS.setUser(user)),
  setAccount: account => dispatch(ACTIONS.setAccount(account)),
  setCaseFile: casefile => dispatch(ACTIONS.setCaseFile(casefile)),
  setDataBase: dataBase => dispatch(ACTIONS.setDataBase(dataBase)),
  setIdEmail: emailInfo => dispatch(ACTIONS.setIdEmail(emailInfo)),
  setFormValues: formValues => dispatch(setFormValues(formValues)),
  setMailContacts: mailContacts =>
    dispatch(ACTIONS.setMailContacts(mailContacts)),
  setDocumentsId: documentsId => dispatch(ACTIONS.setDocumentsId(documentsId)),
  logout: () => {
    dispatch(clearUserCredentials());
    ownProps.navigate('/login', { replace: true });
  },
  setToken: token => dispatch(ACTIONS.setToken(token)),
  setLexonTokenWithoutDocument: tokenWithoutDocument =>
    dispatch(ACTIONS.setLexonTokenWithoutDocument(tokenWithoutDocument)),
  setLexonToken: lexonToken => dispatch(ACTIONS.setLexonToken(lexonToken)),
  setCurrentUser: payload => dispatch(CU_ACTIONS.setCurrentUser(payload)),
  setLastConnection: lastConnection => dispatch(CU_ACTIONS.setLastConnection(lastConnection)),
  setConfigCalendar: config => dispatch(ACTIONS.setConfigCalendar(config)),
  setIdResponsable: config => dispatch(ACTIONS.setIdResponsable(config)),
  setInterveners: interveners => dispatch(ACTIONS.setInterveners(interveners)),
  setSubjectEmail: subjectEmail => dispatch(ACTIONS.setSubjectEmail(subjectEmail)),
  setIsCompose: isCompose => dispatch(ACTIONS.setIsCompose(isCompose)),
  setIdClientLef: id => dispatch(ACTIONS.setIdClientLef(id))
});

const ConnectedUserLexon = withClassNavigate(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(UserLexon))
);
export default ConnectedUserLexon;
